const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.webm', '.avi'];

export const isVideoUrl = (url: string): boolean => {
  const lowered = url.toLowerCase();
  return VIDEO_EXTENSIONS.some((extension) => lowered.includes(extension));
};

export const isVideoMimeType = (mimeType: string): boolean =>
  mimeType.startsWith('video/');

/**
 * For Cloudinary GIF URLs, inject `e_loop` transformation to force infinite looping.
 */
export const withGifLoop = (url: string): string => {
  if (
    !url.includes('cloudinary.com') ||
    !url.toLowerCase().includes('.gif') ||
    url.includes('e_loop')
  ) {
    return url;
  }
  return url.replace('/upload/', '/upload/e_loop/');
};
